import {Component, OnDestroy, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, FormGroupDirective, NgForm, Validators, FormControl} from '@angular/forms';
import {CellEditorComponentBase} from '@shared/components/cell-components/cell-component';
import {IQueryState} from '@shared/store/reducers/query.reducer';
import {select, Store} from '@ngrx/store';
import {QueryProvider} from '@shared/queries/query-provider';
import {takeUntil} from 'rxjs/operators';
import {getQueryResponse} from '@shared/store/selectors/query.selector';
import {Subject} from 'rxjs';

@Component({
    standalone: false,
    selector: 'particle-person-cell-editor',
  templateUrl: './person-cell-editor.component.html',
  styleUrls: ['./person-cell-editor.component.scss']
})
export class PersonCellEditorComponent extends CellEditorComponentBase implements OnInit, OnDestroy {
  personForm: any;
  personFormErrors: any;
  clientType: string;
  private ngUnsubscribe$ = new Subject<void>();
  countryList = [];
  constructor(private formBuilder: FormBuilder,
              private queryStore: Store<IQueryState>) {
    super();
    this.personForm = this.formBuilder.group({
      PrecedingTitle_6_p: [''],
      Title_6_p: [''],
      FirstName_6_p: ['', Validators.required],
      MiddleName_6_p: [''],
      NamePrefix_6_p: [''],
      LastName_6_p: ['', Validators.required],
      GenerationIdentifier_6_p: [''],
      Suffix_6_p: [''],
      GeneralSuffix_6_p: [''],
      DateOfBirth_6_p: ['', [Validators.required]],
      PlaceOfBirth_6_p: ['', Validators.required],
      ResidenceCountryCode_11_p: ['', Validators.required],
      Tin_11_p: [''],
      Email_6_p: ['']
    });
    this.personFormErrors = {
      FirstName_6_p: {},
      LastName_6_p: {},
      DateOfBirth_6_p: {},
      PlaceOfBirth_6_p: {},
      ResidenceCountryCode_11_p: {},
      Tin_11_p: {},
      Email_6_p: {}
    };
  }

  ngOnInit() {
    if (this.item.cells['ID'] && this.item.cells['ID'].value) {
      this.clientType = this.item.cells['ID'].value;
    }
    this.personForm.patchValue({
      PrecedingTitle_6_p: this.getFormFieldValue('PrecedingTitle_6_p'),
      Title_6_p: this.getFormFieldValue('Title_6_p'),
      FirstName_6_p: this.getFormFieldValue('FirstName_6_p'),
      MiddleName_6_p: this.getFormFieldValue('MiddleName_6_p'),
      NamePrefix_6_p: this.getFormFieldValue('NamePrefix_6_p'),
      LastName_6_p: this.getFormFieldValue('LastName_6_p'),
      GenerationIdentifier_6_p: this.getFormFieldValue('GenerationIdentifier_6_p'),
      Suffix_6_p: this.getFormFieldValue('Suffix_6_p'),
      GeneralSuffix_6_p: this.getFormFieldValue('GeneralSuffix_6_p'),
      DateOfBirth_6_p: new Date(this.getFormFieldValue('DateOfBirth_6_p')),
      PlaceOfBirth_6_p: this.getFormFieldValue('PlaceOfBirth_6_p'),
      ResidenceCountryCode_11_p: this.getFormFieldValue('ResidenceCountryCode_11_p'),
      Tin_11_p: this.getFormFieldValue('Tin_11_p'),
      Email_6_p: this.getFormFieldValue('Email_6_p')
    });
    this.personForm.valueChanges.subscribe(() => {
      this.onPersonFormValuesChanged();
    });
    this.queryStore.pipe(takeUntil(this.ngUnsubscribe$), select(getQueryResponse, 'Dac6-CountryCode-Config')).subscribe(response => {
      if (response && response.items) {
        this.countryList = response.items;
      }
    });
    QueryProvider.invokeQuery(this.queryStore, 'Dac6-CountryCode-Config', {});
  }

  onPersonFormValuesChanged() {
    for (const field in this.personFormErrors) {
      if (!this.personFormErrors.hasOwnProperty(field)) {
        continue;
      }
      this.personFormErrors[field] = {};
      const control = this.personForm.get(field);
      if (control && control.dirty && !control.valid) {
        this.personFormErrors[field] = control.errors;
      }
    }
    this.validationChange.emit(this.personForm.valid);
    this.item.cells = {
      ...this.item.cells,
      'Person': this.getPersonData()
    };
    this.valueChanged.emit({item: this.item, fieldDefinition: this.fieldDefinition});
  }
  onOkClicked(): boolean {
    return true;
  }

  private getFormFieldValue(fieldKey: string): string {
    if (this.item.cells[this.fieldDefinition.key] &&
      this.item.cells[this.fieldDefinition.key].value &&
      this.item.cells[this.fieldDefinition.key].value.fieldValues &&
      this.item.cells[this.fieldDefinition.key].value.fieldValues[fieldKey]) {
      return this.item.cells[this.fieldDefinition.key].value.fieldValues[fieldKey];
    }
    return '';
  }

  private getPersonData() {
    if (this.item.cells[this.fieldDefinition.key]) {
      return {
        ...this.item.cells[this.fieldDefinition.key],
        value: {
          fieldValues: this.personForm.value
        }
      };
    } else {
      return {
        value: {
          fieldValues: this.personForm.value
        }
      };
    }
  }
  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }

}
